import React from "react";
import "./Festival_Banner.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Festival_Banner = ({ title, subtitle, bannerImg,simpleText }) => {
  return (
    <section className="Festival_Banner">
      <div className="custom_container">
        <Common_Title pageTitle={title} subTitle={subtitle} simpleText={simpleText}/>

        <div className="banner_img_div">
          <img
            src={process.env.PUBLIC_URL + bannerImg}
            className="banner_img"
          />
        </div>
      </div>
    </section>
  );
};

export default Festival_Banner;
